import React, { FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';

export interface MainLoaderProps {}

const MainLoader: FC<MainLoaderProps> = (props) => {
  const {
    assets: { mainLoader: ThemeMainLoader },
  } = useContext(ThemeContext);

  return (
    <ThemeMainLoader data-testid="MainLoader" {...props} />
  );
};

export default MainLoader;
